<template><div><h1 id="_4-shortcuts" tabindex="-1"><a class="header-anchor" href="#_4-shortcuts"><span>4. Shortcuts</span></a></h1>
<p>Die Shortcuts (Tastenkombinationen) welche für den Aufruf einer bestimmten Funktion dienen, sind in Menus an diversen Stellen beschrieben. Siehe zum Beispiel Menu Daten.</p>
<p>Zum Beispiel die Tastenkombination <code v-pre>(Ctrl+D)</code> löscht einen Datensatz.</p>
<p><img src="@source/manual/user/i/4_shortcut.png" alt="Shortcuts"></p>
<p>Eine Liste der Shortcuts ist unter <code v-pre>Window → Shortcuts</code> aufgeführt.</p>
<h2 id="_4-1-shortcuts-liste" tabindex="-1"><a class="header-anchor" href="#_4-1-shortcuts-liste"><span>4.1. Shortcuts Liste</span></a></h2>
<p>In der folgenden Tabelle sind die wichtigsten Shortcuts mit Beschreibung aufgeführt.</p>
<table>
<thead>
<tr>
<th>Shortcut</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Ctrl+L</td>
<td>Login in funtrade</td>
</tr>
<tr>
<td>Ctrl+Shift+L</td>
<td>Logoff aus funtrade</td>
</tr>
<tr>
<td>Ctrl+1</td>
<td>Adressen</td>
</tr>
<tr>
<td>Ctrl+2</td>
<td>Artikel</td>
</tr>
<tr>
<td>Ctrl+3</td>
<td>Aufträge</td>
</tr>
<tr>
<td>Ctrl+4</td>
<td>Veranstaltungen</td>
</tr>
<tr>
<td>Ctrl+5</td>
<td>Projekte</td>
</tr>
<tr>
<td>Ctrl+6</td>
<td>Buchhaltung</td>
</tr>
<tr>
<td>Ctrl+7</td>
<td>Datenaustausch</td>
</tr>
<tr>
<td>Ctrl+8</td>
<td>System</td>
</tr>
<tr>
<td>Ctrl+N</td>
<td>Neuen Datensatz erfassen</td>
</tr>
<tr>
<td>Ctrl+Shift+N</td>
<td>Datensatz kopieren</td>
</tr>
<tr>
<td>Ctrl+E</td>
<td>Datensatz ändern</td>
</tr>
<tr>
<td>Ctrl+D</td>
<td>Datensatz löschen</td>
</tr>
<tr>
<td>Ctrl+F</td>
<td>Datensatz suchen</td>
</tr>
<tr>
<td>Ctrl+Shift+F</td>
<td>Letzte Suchresultate anzeigen</td>
</tr>
<tr>
<td>Ctrl+L</td>
<td>Auswahlliste in einem Datenfeld anzeigen</td>
</tr>
<tr>
<td>Ctrl+M</td>
<td>Maske maximieren/minimieren</td>
</tr>
<tr>
<td>Ctrl+.</td>
<td>Kontext-Menü Aufruf</td>
</tr>
<tr>
<td>Ctrl+F7</td>
<td>Nächste Maske</td>
</tr>
<tr>
<td>Ctrl+Shift+F7</td>
<td>Vorherige Maske</td>
</tr>
<tr>
<td>Ctrl+Home</td>
<td>Erster Datensatz</td>
</tr>
<tr>
<td>Ctrl+End</td>
<td>Letzter Datensatz</td>
</tr>
<tr>
<td>Ctrl+K</td>
<td>Nächster Datensatz</td>
</tr>
<tr>
<td>Ctrl+Shift+K</td>
<td>Vorheriger Datensatz</td>
</tr>
<tr>
<td>Ctrl+T+K</td>
<td>Aktuelles Datum und Zeit einfügen (nur bei spez.  Zeitfeldern möglich)</td>
</tr>
<tr>
<td>Ctrl+T+U</td>
<td>Umgebung</td>
</tr>
<tr>
<td>F1</td>
<td>Beschreibung anzeigen</td>
</tr>
</tbody>
</table>
</div></template>


